/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function PlaylistPrev(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'PlaylistPrev',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 13 * scale,
      viewBox: '0 0 12 13',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('defs', null,createElement('path', {"d":"M6 6h2v12H6zm3.5 6 8.5 6V6z","id":"wf-svg-PlaylistPrev-__a"})),createElement('g', {"fill":"none","fillRule":"evenodd","opacity":".7"},createElement('path', {"d":"M-6-6h24v24H-6z"}),createElement('g', {"transform":"translate(-6 -6)","fill":"currentColor"},createElement('use', {"filter":"url(#wf-svg-PlaylistPrev-__a)","xlinkHref":"#wf-svg-PlaylistPrev-__a"}),createElement('use', {"xlinkHref":"#wf-svg-PlaylistPrev-__a"}),createElement('use', {"filter":"url(#wf-svg-PlaylistPrev-__wf-svg-playlist-prev-c)","xlinkHref":"#wf-svg-PlaylistPrev-__a"}))))
}
